import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Settings } from '../lib/app.constant';

@Pipe({
  name: 'date'
})
export class DatePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let momentDate = moment(value);
    let isValidDate = momentDate.isValid();
    if (isValidDate) {
      let Date = moment.utc(value).format(Settings.DateFormats.dateFormatFrontend);
      return Date;
    }
    else {
      return "";
    }
  }

}
